import translations from './RateFilter.translations'

export const RATE_RANGES = [
  {
    value: '1-5',
    label: translations.all,
  },
  {
    value: '4-5',
    label: translations.fourFive,
  },
  {
    value: '3-3.9',
    label: translations.threeFour,
  },
  {
    value: '2-2.9',
    label: translations.twoThree,
  },
  {
    value: '1-1.9',
    label: translations.oneTwo,
  },
]
